module.exports = __webpack_public_path__ + "static/pic5-604765406909e7607e2bf2ff98cd1e92.png";